import { ScoredCreditCardProduct } from '@mediaingenuity/totallymoney.types'

import { ActiveCreditCard } from '@appTypes/EligibilityApi.interface'

import { getUuid } from '@utils/getUuid'

export const getClickId = (
    product?: ActiveCreditCard | ScoredCreditCardProduct | null
) => {
    if (product == null || !('clickId' in product) || product.clickId == null) {
        return getUuid()
    }

    return product.clickId
}
